// extracted by mini-css-extract-plugin
export var brand = "_1x-9";
export var compact = "_1x-6";
export var extraSmall = "_1x-7";
export var icon = "_1x-0";
export var large = "_1x-4";
export var light = "_1x-1";
export var medium = "_1x-5";
export var outline = "_1x-b";
export var primaryDark = "_1x-a";
export var primaryLight = "_1x-8";
export var primaryModern = "_1x-c";
export var success = "_1x-2";
export var successSolid = "_1x-3";